import { IFilterOptions } from '@quadminds/shared/commons';

export interface IGetTripsFiltersDto extends IFilterOptions {
    includeExternal?: boolean;
    includeSharedFinished?: boolean;
}
